var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3C4 2.44772 4.44772 2 5 2H17C18.6569 2 20 3.34315 20 5V19C20 20.6569 18.6569 22 17 22H5C4.44772 22 4 21.5523 4 21V3ZM7.25 16C7.25 16.4142 7.58579 16.75 8 16.75H16C16.4142 16.75 16.75 16.4142 16.75 16C16.75 15.5858 16.4142 15.25 16 15.25H8C7.58579 15.25 7.25 15.5858 7.25 16ZM9.25 19C9.25 19.4142 9.58579 19.75 10 19.75H14C14.4142 19.75 14.75 19.4142 14.75 19C14.75 18.5858 14.4142 18.25 14 18.25H10C9.58579 18.25 9.25 18.5858 9.25 19ZM8 8.45681C8 9.90707 9.60777 11.4409 10.7847 12.3695C11.3175 12.7898 11.5839 13 12 13C12.4161 13 12.6825 12.7898 13.2153 12.3695C14.3922 11.4409 16 9.90709 16 8.45679C16 6.03402 13.7999 5.12947 12 7.00105C10.2001 5.12947 8 6.03402 8 8.45681Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitation);
export default __webpack_public_path__ + "static/media/invitation.77f0f9d2a480e54229cea6c04c23d602.svg";
export { ForwardRef as ReactComponent };